import AuthStore from "./AuthStore";
import LanguageStore from "./LanguageStore";
import AppStore from "./AppStore";
import DocumentStore from "./DocumentStore";
import AnnouncementStore from "./AnnouncementStore";
import TrainingStore from "./TrainingStore";
import ProductStore from "./ProductStore";
import ProductCategoryStore from "./ProductCategoryStore";
import ShoppingCartStore from "./ShoppingCartStore";
import OrderStore from "./OrderStore";
import PageStore from "./PageStore";
import CurrencyStore from "./CurrencyStore";
import StoreStore from "./StoreStore";
import AccountNumberStore from "./AccountNumberStore";
import PaymentNotificationStore from "./PaymentNotificationStore";
import PaymentTypeStore from "./PaymentTypeStore";

const stores = {
    AuthStore,
    LanguageStore,
    AppStore,
    DocumentStore,
    AnnouncementStore,
    TrainingStore,
    ProductStore,
    ProductCategoryStore,
    ShoppingCartStore,
    OrderStore,
    PageStore,
    CurrencyStore,
    StoreStore,
    AccountNumberStore,
    PaymentNotificationStore,
    PaymentTypeStore
}

export default stores